/* Stittsworth Meats theme.js — nav, AJAX cart drawer, scroll reveals, counters.
   Vanilla port of the storefront's GSAP behaviors (tasteful subset, reduced-motion aware). */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function (cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
  };

  /* ── Nav: scroll blur ── */
  var nav = document.querySelector('.site-nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('nav-scrolled', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Nav: dropdown groups (hover intent + click) ── */
  document.querySelectorAll('.nav-group').forEach(function (group) {
    var btn = group.querySelector('.nav-group-btn');
    var timer = null;
    var open = function () { clearTimeout(timer); closeAll(group); group.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); };
    var close = function () { group.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); };
    var closeAll = function (except) {
      document.querySelectorAll('.nav-group.open').forEach(function (g) { if (g !== except) { g.classList.remove('open'); var b = g.querySelector('.nav-group-btn'); if (b) b.setAttribute('aria-expanded', 'false'); } });
    };
    group.addEventListener('mouseenter', open);
    group.addEventListener('mouseleave', function () { timer = setTimeout(close, 150); });
    btn.addEventListener('click', function () { group.classList.contains('open') ? close() : open(); });
  });
  document.addEventListener('mousedown', function (e) {
    if (!e.target.closest('.nav-group')) {
      document.querySelectorAll('.nav-group.open').forEach(function (g) { g.classList.remove('open'); });
    }
  });

  /* ── Mobile menu ── */
  var burger = document.querySelector('.nav-burger');
  var mobileMenu = document.getElementById('mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileMenu.classList.remove('open'); burger.classList.remove('open'); document.body.style.overflow = '';
      });
    });
  }

  /* ── Escape closes overlays ── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.nav-group.open').forEach(function (g) { g.classList.remove('open'); });
    if (mobileMenu && mobileMenu.classList.contains('open')) { mobileMenu.classList.remove('open'); burger.classList.remove('open'); document.body.style.overflow = ''; }
    closeCart();
  });

  /* ── Scroll reveals ── */
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('revealed'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal, .reveal-stagger, .timeline .event, .footer-bottom').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal, .reveal-stagger, .timeline .event, .footer-bottom').forEach(function (el) { el.classList.add('revealed'); });
  }

  /* ── Stat counters (count up on first view) ── */
  var easeOutCubic = function (t) { return 1 - Math.pow(1 - t, 3); };
  var counters = document.querySelectorAll('[data-target]');
  if (counters.length) {
    var runCounter = function (el) {
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      var comma = el.getAttribute('data-comma') === 'true';
      var f = function (n) { return (comma ? n.toLocaleString('en-US') : String(n)) + suffix; };
      if (reduced) { el.textContent = f(target); return; }
      var start = performance.now();
      var tick = function (now) {
        var p = Math.min((now - start) / 1800, 1);
        el.textContent = f(Math.round(target * easeOutCubic(p)));
        if (p < 1) requestAnimationFrame(tick);
      };
      el.textContent = f(0);
      requestAnimationFrame(tick);
    };
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { runCounter(entry.target); cio.unobserve(entry.target); }
        });
      }, { threshold: 0.25 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(runCounter);
    }
  }

  /* ── Timeline growing ember line ── */
  var tl = document.querySelector('.timeline');
  var tlFill = tl && tl.querySelector('.line-fill');
  if (tl && tlFill && !reduced) {
    var onTlScroll = function () {
      var rect = tl.getBoundingClientRect();
      var vh = window.innerHeight;
      var progress = Math.min(1, Math.max(0, (vh * 0.8 - rect.top) / (rect.height + vh * 0.6)));
      tlFill.style.transform = 'translateX(-50%) scaleY(' + progress + ')';
    };
    window.addEventListener('scroll', onTlScroll, { passive: true });
    onTlScroll();
  } else if (tlFill) {
    tlFill.style.transform = 'translateX(-50%) scaleY(1)';
  }

  /* ── Cart drawer + AJAX cart ── */
  var drawer = document.getElementById('cart-drawer');
  var backdrop = document.getElementById('cart-backdrop');
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.stwOpenCart = openCart;
  if (backdrop) backdrop.addEventListener('click', closeCart);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCart();
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
  });

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count > 0 ? (cart.item_count > 9 ? '9+' : String(cart.item_count)) : '';
    });
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var countEl = drawer.querySelector('[data-cart-head-count]');
    if (countEl) countEl.textContent = cart.item_count ? cart.item_count + (cart.item_count === 1 ? ' item' : ' items') : '';
    var threshold = parseFloat(drawer.getAttribute('data-free-ship') || '199') * 100;
    if (!cart.item_count) {
      if (body) body.innerHTML =
        '<div class="cart-empty">' +
        '<svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path></svg>' +
        '<p class="t1">Your cart is empty</p>' +
        '<p class="t2">The smokehouse awaits. Ships frozen nationwide.</p>' +
        '<a href="/collections/all">Shop Our Cuts — Ships Frozen</a>' +
        '</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    var subtotal = cart.items_subtotal_price;
    var remaining = Math.max(0, threshold - subtotal);
    var pct = Math.min(100, (subtotal / threshold) * 100);
    var html = '<div class="freeship-meter" aria-live="polite"><p>' +
      (remaining <= 0
        ? '<span class="em">You&rsquo;ve unlocked FREE shipping.</span> Nicely done.'
        : 'You&rsquo;re <span class="em">' + fmt(remaining) + '</span> away from <strong>FREE shipping</strong>') +
      '</p><div class="bar"><div class="fill' + (remaining <= 0 ? ' unlocked' : '') + '" style="width:' + pct + '%"></div></div>' +
      (remaining > 0
        ? '<p class="upsell">Add a little more: <a href="/products/pocket-meat-smokehouse-club">Pocket Meat</a> · <a href="/products/honey-bbq-sticks">Honey BBQ Sticks</a> · <a href="/products/original-sausage">Original Brats</a></p>'
        : '') +
      '</div>';
    cart.items.forEach(function (item) {
      html += '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<a class="thumb" href="' + item.url + '">' + (item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="meta">' +
        '<a class="name" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="variant">' + item.variant_title + '</p>' : '') +
        '<div class="price-row"><span class="price">' + fmt(item.final_price) + '</span>' +
        (item.original_price > item.final_price ? '<span class="compare">' + fmt(item.original_price) + '</span>' : '') + '</div>' +
        '<div class="controls"><div class="qty-stepper">' +
        '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
        '<span class="qty">' + item.quantity + '</span>' +
        '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
        '</div><button type="button" class="remove" data-line-remove>Remove</button></div>' +
        '</div></div>';
    });
    html += '<div class="cart-trust">' +
      ['USDA Inspected', 'Family Crafted', 'Ships Frozen'].map(function (b) {
        return '<div class="badge"><svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>' + b + '</div>';
      }).join('') + '</div>';
    if (body) body.innerHTML = html;
    if (foot) {
      foot.style.display = '';
      var st = foot.querySelector('[data-subtotal]');
      if (st) st.textContent = fmt(subtotal);
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { window.stwCart = cart; renderCart(cart); return cart; });
  }
  window.stwFetchCart = fetchCart;

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { window.stwCart = cart; renderCart(cart); });
  }

  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-change]');
    var removeBtn = e.target.closest('[data-line-remove]');
    var lineEl = e.target.closest('[data-line-key]');
    if (!lineEl || (!stepBtn && !removeBtn)) return;
    var key = lineEl.getAttribute('data-line-key');
    if (removeBtn) { changeLine(key, 0); return; }
    var qtyEl = lineEl.querySelector('.qty');
    var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) + parseInt(stepBtn.getAttribute('data-qty-change'), 10);
    changeLine(key, Math.max(0, qty));
  });

  /* 11/01: visible error when an add fails (/cart/add.js non-200 or network). */
  function addError(r) {
    return r.json().catch(function () { return {}; }).then(function (j) {
      var e = new Error('add failed'); e.userMessage = (j && (j.description || j.message)) || ''; throw e;
    });
  }
  function showAddError(anchor, err) {
    if (!anchor) return;
    var host = anchor.closest('.pdp-buy-box') || anchor.closest('.quick-view') || anchor.closest('form') || anchor.parentNode;
    var box = host.querySelector(':scope > .atc-error');
    if (!box) { box = document.createElement('p'); box.className = 'atc-error'; box.setAttribute('role', 'alert'); host.appendChild(box); }
    var msg = (err && err.userMessage) ? String(err.userMessage) : '';
    box.textContent = 'Couldn’t add to cart' + (msg ? ': ' + msg : '. Please try again or call the shop at 218-751-1320.');
    box.hidden = false;
    clearTimeout(box._t); box._t = setTimeout(function () { box.hidden = true; }, 8000);
  }
  window.stwShowAddError = showAddError;

  /* Add-to-cart: any form[data-ajax-cart], and quick-add buttons */
  window.stwAddToCart = function (variantId, quantity, props) {
    var payload = { id: variantId, quantity: quantity || 1 };
    if (props) payload.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return addError(r);
      return fetchCart();
    }).then(function () { openCart(); });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) return addError(r); return fetchCart(); })
      .then(function () {
        if (btn) { btn.textContent = '✓ Added to Cart'; setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2000); }
        openCart();
      })
      .catch(function (err) { if (btn) { btn.disabled = false; btn.textContent = original; } showAddError(btn || form, err); });
  });

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    e.stopPropagation();
    var original = quick.textContent;
    quick.textContent = 'Adding…';
    window.stwAddToCart(quick.getAttribute('data-quick-add'), 1).then(function () {
      quick.textContent = '✓ Added!';
      setTimeout(function () { quick.textContent = original; }, 1400);
    }).catch(function (err) { quick.textContent = original; showAddError(quick, err); });
  });

  /* PDP quantity steppers (outside the cart) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdp-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty-stepper');
    var input = wrap && wrap.querySelector('input[name="quantity"]');
    var display = wrap && wrap.querySelector('.qty');
    if (!input) return;
    var v = Math.min(99, Math.max(1, parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-pdp-qty'), 10)));
    input.value = v;
    if (display) display.textContent = v;
  });

  /* Initial cart state */
  fetchCart();
})();
